import React from "react";
import ShortTextIcon from "@mui/icons-material/ShortText";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import TouchAppOutlinedIcon from "@mui/icons-material/TouchAppOutlined";
import FormatListBulletedOutlinedIcon from "@mui/icons-material/FormatListBulletedOutlined";
import LinearScaleIcon from "@mui/icons-material/LinearScale";
import ToggleOffOutlinedIcon from "@mui/icons-material/ToggleOffOutlined";
import MoodIcon from "@mui/icons-material/Mood";
import Crop169Icon from "@mui/icons-material/Crop169";
import AccessibilityNewOutlinedIcon from "@mui/icons-material/AccessibilityNewOutlined";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import SubdirectoryArrowRightIcon from "@mui/icons-material/SubdirectoryArrowRight";

import { subTypes } from "./itemTypes";

const manualUrl = "https://m-path.io/manual/knowledge-base/";

export const questionTypes = {
  [subTypes.open]: {
    type: subTypes.open,
    icon: <ShortTextIcon />,
    manualUrl: manualUrl + "open-question",
  },
  [subTypes.singleChoice]: {
    type: subTypes.singleChoice,
    icon: <RadioButtonCheckedIcon />,
    manualUrl: manualUrl + "multiple-choice/#allow-only-one-answer",
  },
  [subTypes.multipleChoice]: {
    type: subTypes.multipleChoice,
    icon: <CheckBoxOutlinedIcon />,
    manualUrl: manualUrl + "multiple-choice/#allow-multiple-answers",
  },
  [subTypes.yesno]: {
    type: subTypes.yesno,
    icon: <ToggleOffOutlinedIcon />,
    manualUrl: manualUrl + "yes-no-question",
  },
  [subTypes.order]: {
    type: subTypes.order,
    icon: <TouchAppOutlinedIcon />,
    manualUrl: manualUrl + "multiple-choice/#3-order",
  },
  [subTypes.likert]: {
    type: subTypes.likert,
    icon: <FormatListBulletedOutlinedIcon />,
    manualUrl: manualUrl + "multiple-choice/#2-likert-scale",
  },
  [subTypes.multiSmiley]: {
    type: subTypes.multiSmiley,
    icon: <MoodIcon />,
    manualUrl: manualUrl + "multiple-choice/#4-multi-smiley",
  },
  [subTypes.bodyParts]: {
    type: subTypes.bodyParts,
    icon: <AccessibilityNewOutlinedIcon />,
    manualUrl: manualUrl + "multiple-choice/#5-body-parts",
  },
  [subTypes.slider]: {
    type: subTypes.slider,
    icon: <LinearScaleIcon />,
    manualUrl: manualUrl + "slider-question",
  },
  [subTypes.sliderNegPos]: {
    type: subTypes.slider,
    icon: <LinearScaleIcon />,
    manualUrl: manualUrl + "slider-question",
  },
  [subTypes.sliderNeutralPos]: {
    type: subTypes.slider,
    icon: <LinearScaleIcon />,
    manualUrl: manualUrl + "slider-question",
  },
  [subTypes.smiley]: {
    type: subTypes.smiley,
    icon: <MoodIcon />,
    manualUrl: manualUrl + "smiley-question",
  },
  [subTypes.container]: {
    type: subTypes.container,
    icon: <Crop169Icon />,
    manualUrl: manualUrl + "container",
  },
  [subTypes.time]: {
    type: subTypes.time,
    icon: <AccessTimeIcon />,
    manualUrl: manualUrl + "time-question",
  },
  [subTypes.text]: {
    type: subTypes.text,
    icon: <TextFieldsIcon />,
    manualUrl: manualUrl + "media-items/#text",
  },
  ["conditional"]: {
    type: "conditional",
    icon: <SubdirectoryArrowRightIcon />,
    manualUrl: manualUrl + "what-is-a-conditional-question/",
  },
};

// show basic questions
const basic = [subTypes.open, subTypes.multipleChoice, subTypes.slider];
export const basicQuestions = basic.map(
  (questionType) => questionTypes[questionType]
);

const all = [
  subTypes.smiley,
  subTypes.singleChoice,
  subTypes.multipleChoice,
  subTypes.slider,
  subTypes.likert,
  subTypes.open,
  subTypes.yesno,
  subTypes.multiSmiley,
  subTypes.bodyParts,
  subTypes.order,
  subTypes.text,
  "conditional"
];
export const allQuestions = all.map(
  (questionType) => questionTypes[questionType]
);

const choice = [
  subTypes.singleChoice,
  subTypes.multipleChoice,
  subTypes.likert,
  subTypes.order,
];
export const choiceQuestions = choice.map(
  (questionType) => questionTypes[questionType]
);
